<div class="container-fluid">
  <div class="row">
    <div id="markets-search-title" class="col">
      <h1 i18n="@@upp.markets.search.title">Search Markets</h1>
    </div>
  </div>
  <div class="row">
    <div class="container-fluid">
      <ama-loading-alert
        [sendingStatus]="(marketsDeleteSending$ | async) ?? false"
        message="Loading..."
        i18n-message="@@upp.global.messages.loading"
      >
      </ama-loading-alert>
    </div>

    <ama-upp-notification
      id="markets-search-notification"
      class="col"
      [mainMessages]="mainMessages"
      [notification]="(getNotification() | async)!"
      (closeNotificationEvent)="closeNotification()"
    >
    </ama-upp-notification>
  </div>
  <div class="row">
    <div id="search-criteria" class="col">
      <ama-ng-upp-markets-search-criteria
        [sendingStatus]="(marketsSearchSending$ | async) ?? false"
        (searchMarkets)="searchMarketsList($event)"
        (clearMarkets)="clearMarkets()"
      >
      </ama-ng-upp-markets-search-criteria>
    </div>
  </div>
  @if (!agGridTablesActivated) {
    <div class="row">
      <div id="search-result" class="col">
        <ama-ng-upp-basic-search-result-table
          [searchResults]="(getSearchResults() | async) ?? undefined"
          [selectedNames]="(selectedMarketNames$ | async) ?? undefined"
          [sendingStatus]="(marketsDeleteSending$ | async) ?? false"
          [isLookup]="lookup"
          [lookupValues]="lookupValues"
          [lookupOptions]="lookupOptions"
          [sourceComponent]="getSourceComponent()"
          [entryType]="getEntryType()"
          [recordToSearchResult]="recordToSearchResult"
          [entryToUpdateCreator]="entryToUpdateCreator"
          [entryToUpdateNameResolver]="$any(entryToUpdateNameResolver)"
          (deleteEntry)="deleteMarketsEntry($event)"
          (clearTableEvent)="clearMarketsResults()"
          (showDetail)="showMarketsDetail($event)"
          (modifyDetail)="modifyMarketsDetail($event)"
          (copyDetail)="copyMarketsDetail($event)"
          [managePermission]="managePermission"
          [displayableFields]="displayableFields"
        >
        </ama-ng-upp-basic-search-result-table>
      </div>
    </div>
  } @else {
    @if (lookup) {
      <div class="mt-3 mb-3">
        <button class="btn btn-link me-auto p-2" (click)="goBack()">
          <span class="fa-angle-left df-icon-wtd me-2"></span>
          {{ goBackLinkText }}
        </button>
      </div>
    }
    <div class="row mt-7">
      <div id="search-result" class="col">
        <div [class]="agGridTheme" class="grid-container">
          <ag-grid-angular
            [rowData]="getSearchResults() | async"
            [columnDefs]="columnDefs"
            [gridOptions]="gridOptions"
            [defaultColDef]="defaultColDef"
            (gridReady)="onGridReady($event)"
            class="grid-component"
          ></ag-grid-angular>
        </div>
      </div>
    </div>
  }
</div>
